import { Typography, colors } from '@leapeasy/ui-kit';
import { Box } from '@mui/material';
import { getSupportingRoleGuideLabels } from 'utils/portalGuideUi';

export const User = ({ userRole }) => {
  return (
    <Box marginLeft="30px">
      {userRole === 'admin' && (
        <>
          <Typography
            variant="h2"
            style={{
              color: colors.purple[900],
              fontWeight: '500',
              paddingBottom: '10px',
              paddingTop: '10px',
            }}
          >
            Admin
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Leap staff with cross-account access. Admins can view any account perspective, update
            delegated properties, invite users on behalf of an Operator account, and upload SOP
            documents to an Operator profile.
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Admins have access to all supporting views and user lists, and can invite{' '}
            {getSupportingRoleGuideLabels()} users.
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            The dashboard aggregates data across all delegated properties and units, with the
            ability to drill into individual regions or properties. Admins can also view the
            dashboard from the perspective of supporting staff ({getSupportingRoleGuideLabels()}).
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Admins can update property delegations, send invites, and approve delegation requests
            from supporting roles.
          </Typography>
        </>
      )}
      {(userRole === 'admin' || userRole === 'll') && (
        <>
          <Typography
            variant="h2"
            style={{
              color: colors.purple[900],
              fontWeight: '500',
              paddingBottom: '10px',
              paddingTop: '10px',
            }}
          >
            Operator
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Operator is the highest operator-level permission after Admin.
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Operator users have access to all supporting views and user lists, and can invite{' '}
            {getSupportingRoleGuideLabels()} users.
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            The dashboard aggregates data across all delegated properties and units, with the
            ability to drill into individual regions or properties. Operator users can also view the
            dashboard from the perspective of supporting staff ({getSupportingRoleGuideLabels()}).
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Operator users can update property delegations, invite new users, and approve delegation
            requests from supporting roles.
          </Typography>
        </>
      )}
      {(userRole === 'admin' || userRole === 'll' || userRole === 'vp') && (
        <>
          <Typography
            variant="h2"
            style={{
              color: colors.purple[900],
              fontWeight: '500',
              paddingBottom: '10px',
              paddingTop: '10px',
            }}
          >
            Full Portfolio
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Full Portfolio users see an interactive dashboard across all delegated properties and
            units, with the ability to drill into individual Multi-Site or property views.
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            They can view the dashboard from the perspective of supporting staff (Multi-Site and
            Property Manager).
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Full Portfolio users can update property delegations, invite new users, and approve
            delegation requests from Multi-Site users and other supporting roles.
          </Typography>
        </>
      )}
      {(userRole === 'admin' || userRole === 'll' || userRole === 'vp' || userRole === 'rm') && (
        <>
          <Typography
            variant="h2"
            style={{
              color: colors.purple[900],
              fontWeight: '500',
              paddingBottom: '10px',
              paddingTop: '10px',
            }}
          >
            Multi-Site
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Multi-Site users see an interactive dashboard across multiple delegated properties, and
            can drill into individual Property Manager or single-property views.
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            They can view the dashboard from the perspective of supporting Property Manager users.
          </Typography>
          <Typography variant="body2" style={{ color: colors.purple[900], fontWeight: '500' }}>
            Multi-Site users can request property delegation changes from a higher-level user,
            invite Property Manager users, and manage Property Manager invitations.
          </Typography>
        </>
      )}
      {(userRole === 'admin' ||
        userRole === 'll' ||
        userRole === 'vp' ||
        userRole === 'rm' ||
        userRole === 'pm') && (
        <>
          <Typography
            variant="h2"
            style={{
              color: colors.purple[900],
              fontWeight: '500',
              paddingBottom: '10px',
              paddingTop: '10px',
            }}
          >
            Property Manager
          </Typography>
          <Typography
            variant="body2"
            style={{ color: colors.purple[900], fontWeight: '500', marginBottom: '30px' }}
          >
            Property Manager users see an interactive dashboard scoped to their delegated property
            and units. They typically have access to one property, can file claims for issued
            policies, and work within the Portfolio section of the menu.
          </Typography>
        </>
      )}
    </Box>
  );
};
